export default __webpack_public_path__ + "static/cranes-a6c52e6b1a7b2438a6c09957dba2bab1.png";